import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editCollection,
  viewOneCollection,
} from "../../Redux/Actions/collectionsActions";
import AddImage from "../../Global Functions/addImage";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import TextInput from "../../Global Functions/textInput";

const EditCollections = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [collectionState, setCollectionState] = useState({
    id: id,
    name: "",
    image: "",
    icon: "",
    three_d_icon: "",
    banner_image: "",
    banner_title: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(viewOneCollection(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { individualCollection } = useSelector(
    (state) => state.collections || {}
  );

  useEffect(() => {
    if (individualCollection?.data) {
      setCollectionState((prevData) => ({
        ...prevData,
        ...individualCollection?.data,
        id: id,
      }));
    }
  }, [individualCollection, id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (collectionState) {
        const filteredData = Object.fromEntries(
          Object.entries(collectionState).filter(
            ([_, value]) =>
              value !== "" && value !== null && value !== undefined
          )
        );

        const response = await dispatch(editCollection(filteredData));

        if (response.statusCode === 200) {
          navigate("/collections");
        }
      }
    } catch (error) {
      console.log(error?.data?.response?.message);
    }
  };

  const handleImageUpload = async (event, type) => {
    const uploadedFile = event.target.files[0];

    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);

    if (responseUrl) {
      setCollectionState((prevData) => ({ ...prevData, [type]: responseUrl }));
    }
  };

  return (
    <MainLayout>
      <div
        style={{
          marginTop: "10px",
          paddingTop: "10px",
          background: "white",
          borderRadius: "25px",
          width: "100%",
          gridColumn: "2/7",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
          }}
        >
          <h1>Edit Collection</h1>
          <Link to="/collections">
            <button className="button-class">Go Back</button>
          </Link>
        </div>
        <form style={{ padding: "0px 20px" }}>
          <div className="flex-container gap-10 flex-center margin-h-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="image">
                Collection Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="image"
                onChange={(event) => handleImageUpload(event, "image")}
                id="image"
              />
              <label className="label-class-image" for="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.image}
                keyField="image"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="icon">
                Collection Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="icon"
                id="icon"
                onChange={(event) => handleImageUpload(event, "icon")}
              />
              <label className="label-class-image" for="icon">
                Click to Upload Icon
              </label>
              <ImageShowerModalGlobal
                file={collectionState.icon}
                keyField="icon"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container gap-10 flex-center margin-h-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Banner Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="banner_image"
                accept="image/*"
                name="banner_image"
                onChange={(event) => handleImageUpload(event, "banner_image")}
              />
              <label className="label-class-image" htmlFor="banner_image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.banner_image}
                keyField="banner_image"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload 3D Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="three_d_icon"
                accept="image/*"
                name="three_d_icon"
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
              />
              <label className="label-class-image" htmlFor="three_d_icon">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.three_d_icon}
                keyField="three_d_icon"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container gap-10 flex-center margin-h-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="change-name">
                Collection Name
              </span>
              <input
                className="input-class"
                type="text"
                value={collectionState.name}
                name="name"
                onChange={(event) =>
                  setCollectionState((prevData) => ({
                    ...prevData,
                    name: event.target.value,
                  }))
                }
                placeholder="Enter Name"
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                name="banner_title"
                placeholder="Enter Title"
                value={collectionState.banner_title}
                onChange={(event) =>
                  setCollectionState({
                    ...collectionState,
                    banner_title: event.target.value,
                  })
                }
                label="Banner Title"
              ></TextInput>
            </div>
          </div>

          <div className="flex-end" style={{ margin: "20px 0px" }}>
            <Link to="/collections">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button onClick={handleSubmit} className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCollections;
